import * as React from "react";

export type NotificationSeverity = "success" | "error" | "info" | "warning";

/**
 * Visual treatment for a notification.
 *
 * - ``"alert"`` (default): the standard severity-colored MUI alert used
 *   throughout the app.
 * - ``"accent"``: a softer, indigo-accented card for one-off informational
 *   toasts that want a distinct, calmer look (e.g. the "private fork"
 *   confirmation). Severity is ignored for this variant.
 */
export type NotificationVariant = "alert" | "accent";

export interface Notification {
  id: string;
  message: string;
  severity: NotificationSeverity;
  duration: number;
  variant: NotificationVariant;
}

/**
 * @param severity Defaults to "success" if omitted.
 * @param duration Auto-dismiss delay in ms. Defaults to 3000.
 * @param variant Visual treatment. Defaults to "alert".
 */
export type ShowNotification = (
  message: string,
  severity?: NotificationSeverity,
  duration?: number,
  variant?: NotificationVariant,
) => void;

export const NotificationDispatchContext =
  React.createContext<ShowNotification>(() => {});
